var map = {
	"./bg/strings.json": 1887,
	"./cs/strings.json": 1888,
	"./da/strings.json": 1889,
	"./de/strings.json": 1890,
	"./el/strings.json": 1891,
	"./es-419/strings.json": 1892,
	"./es/strings.json": 1893,
	"./et/strings.json": 1894,
	"./fi/strings.json": 1895,
	"./fr-CA/strings.json": 1896,
	"./fr/strings.json": 1897,
	"./it/strings.json": 1898,
	"./lt/strings.json": 1899,
	"./lv/strings.json": 1900,
	"./nl/strings.json": 1901,
	"./no/strings.json": 1902,
	"./pl/strings.json": 1903,
	"./pseudo/strings.json": 1904,
	"./pt/strings.json": 1905,
	"./ro/strings.json": 1906,
	"./sk/strings.json": 1907,
	"./sl/strings.json": 1908,
	"./sv/strings.json": 1909,
	"./zh-CN/strings.json": 1910,
	"./zh-TW/strings.json": 1911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1886;